// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal-module__container___1ODcg","close-btn":"Modal-module__close-btn___2D__x"};